<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19zcQVp/tc-custom/9781504013611.jpg?1703825146752" alt="This image is the cover for the book White Horse"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">White Horse
      </h1>
      <p class="bookDescription body article font2">
        <b>Writing can open doors to a better life for Raina—but it’s up to her not to slam them shut</b><br/><br/> Raina doesn’t trust anyone. People either hurt you or leave you—or they die, which is the same thing, really. She used to trust her mother, until her mother chose heroin and a long series of abusive boyfriends over her. Now, sixteen-year-old Raina panhandles on the streets and sleeps in abandoned buildings with her boyfriend, Sonny. She doesn’t tell anyone the truth about her life, at least not out loud, but she can’t stop it from coming out in the poems and stories she writes for her teacher Miss Johnson.<br/>  <br/> Miss Johnson knows that Raina is smart, perceptive, and utterly locked inside of herself. The concerned teacher reaches out again and again, but Raina’s dreams have been crushed by reality too often. What will it take for Raina to ask for help?<br/><br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cynthia D. Grant
      </h2>
      
      <p class="authorDescription body article">Cynthia D. Grant has published twelve young adult fiction novels since 1980. In 1991 she won the first PEN/Norma Klein Award, for &ldquo;an emerging voice among American writers of children&rsquo;s fiction.&rdquo; Over the years, Grant has received numerous other distinctions. Unfortunately, her Massachusetts upbringing prohibits her from showing off. She lives in the mountains outside Cloverdale, California, and has one husband, Eric Neel; two sons, Morgan Heatley-Grant and Forest Neel-Grant; two cats, Kelsey, an orange tom, and Billie, a barn cat&ndash;barracuda mix; and Mike the Wonder Dog, who packs two-hundred-plus pounds of personality into a seven-pound body.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?14e2265e